import "./GradientLegend.scss";
import React from "react";
import { formatNumber } from "../utils/format-utils";

interface GradientLegendProps {
  title?: string;
  bins: number[];
  useConvergent: boolean;
  legendStyle?: {
    background: string;
  };
  formatLabel?: (val: number) => string;
  reverse?: boolean;
}

const divergentLegendRectangleStyle = {
  background:
    "linear-gradient(90deg, #fd2c29 0%, #fd2c29 12.5%, #ff726e 12.5%, #ff726e 25%, #ffb1b0 25%, #ffb1b0 37.5%, #ffe5e6 37.5%, #ffe5e6 50%, #ccfaff 50%, #ccfaff 62.5%, #94eefa 62.5%, #94eefa 75%, #45d9ed 75%, #45d9ed 87.5%, #15c4db 87.5%, #15c4db 100%)",
};

const convergentLegendRectangleStyle = {
  background:
    "linear-gradient(90deg, #E8E5FF 0%, #E8E5FF 16.67%, #B5A6FF 16.67%, #B5A6FF 33.33%, #977AFF 33.33%, #977AFF 50%, #8254FF 50%, #8254FF 66.67%, #6B2DEF 66.67%, #6B2DEF 83.33%, #5200CE 83.33%, #5200CE 100%)",
};

export const GradientLegend: React.FC<GradientLegendProps> = ({
  title,
  bins,
  useConvergent = true,
  legendStyle,
  formatLabel = val => formatNumber(val, 2),
  reverse,
}) => {
  const styleToUse = legendStyle
    ? legendStyle
    : useConvergent
    ? convergentLegendRectangleStyle
    : divergentLegendRectangleStyle;

  const binsToUse = reverse ? [...bins].reverse() : bins;

  // Check if any bins contain NaN or Infinity
  const hasInvalidData = binsToUse.some(value => Number.isNaN(value) || !Number.isFinite(value));

  return (
    <div className="gradientLegend">
      {title && <div className="legendTitle">{title}</div>}
      <div className="legendContentsBox">
        <div className="legendContents">
          <div className="rectangle" style={styleToUse}></div>
          <div className="legendTickContainer">
            {binsToUse.map((value, index) => {
              const percentage = (index / (binsToUse.length - 1)) * 100;
              if (index === 0) {
                return (
                  <div
                    className="legendTickBox"
                    key={index}
                    style={{ left: `${percentage + 0.1}%` }}
                  >
                    <div className="legendTickLine"></div>
                    {!hasInvalidData && <div className="legendTickText">{formatLabel(value)}</div>}
                  </div>
                );
              } else if (index === binsToUse.length - 1) {
                return (
                  <div
                    className="legendTickBox"
                    key={index}
                    style={{ left: `${percentage - 0.1}%` }}
                  >
                    <div className="legendTickLine"></div>
                    {!hasInvalidData && <div className="legendTickText">{formatLabel(value)}</div>}
                  </div>
                );
              } else {
                return (
                  <div className="legendTickBox" key={index} style={{ left: `${percentage}%` }}>
                    <div className="legendTickLine"></div>
                    {!hasInvalidData && <div className="legendTickText">{formatLabel(value)}</div>}
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientLegend;
